module.exports = __webpack_public_path__ + "img/diy-QiYeWzXn.adae0557.svg";